import { render, staticRenderFns } from "./dryEyeTreatment.vue?vue&type=template&id=e2bad48a&scoped=true&"
import script from "./dryEyeTreatment.vue?vue&type=script&lang=js&"
export * from "./dryEyeTreatment.vue?vue&type=script&lang=js&"
import style0 from "./dryEyeTreatment.vue?vue&type=style&index=0&id=e2bad48a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2bad48a",
  null
  
)

export default component.exports